import styled from 'styled-components/macro';

export const StyledBottomBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  line-height: 24px;
  font-size: 16px;
  row-gap: 4px;
`;
